let loadPromise = null;
const callbackName = '__fusaGoogleMapsLoaded';

export const loadGoogleMapsScript = () => {
  if (typeof window.google?.maps?.Map === 'function') return Promise.resolve();
  if (loadPromise) return loadPromise;
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) return Promise.reject(new Error('Google Maps is not configured'));

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    window[callbackName] = () => {
      delete window[callbackName];
      if (typeof window.google?.maps?.Map === 'function') resolve();
      else {
        loadPromise = null;
        reject(new Error('Google Maps did not initialize'));
      }
    };
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&loading=async&callback=${callbackName}`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      delete window[callbackName];
      loadPromise = null;
      reject(new Error('Failed to load Google Maps'));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
};
